import React, { useEffect, useState } from 'react'

export default function TestimonialSlider() {
  const [testimonials, setTestimonials] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('https://api.dev.auxo.dk/public/content/kundeanmeldelser')
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setTestimonials(data)
        }
        setLoading(false)
      })
      .catch((err) => {
        console.error('Fejl ved hentning af anmeldelser:', err)
        setLoading(false)
      })
  }, [])

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#DFB587] border-t-transparent" />
      </div>
    )
  }

  if (testimonials.length === 0) return null

  // Duplicate testimonials to ensure smooth infinite scrolling
  const duplicatedTestimonials = [...testimonials, ...testimonials, ...testimonials]

  return (
    <section className="relative overflow-hidden bg-[#F5F2EB] py-20 border-y border-stone-300/80">
      <div className="mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8 xl:px-12">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#9b784a]">
            Kundeudtalelser
          </span>
          <h2 className="mt-2 text-3xl font-bold tracking-tight text-neutral-900 sm:text-4xl font-display">
            Det siger kunderne om RECARS
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-neutral-600">
            Vi lever af tilfredse kunder. Læs her om deres oplevelser med at købe eller sælge bil hos Recars ApS.
          </p>
        </div>
      </div>

      {/* Infinite Slider Container */}
      <div className="relative mt-16 flex w-full overflow-x-hidden py-4">
        {/* Gradient overlays for premium fade effect */}
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 md:w-32 bg-gradient-to-r from-[#F5F2EB] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 md:w-32 bg-gradient-to-l from-[#F5F2EB] to-transparent" />

        <div className="infinite-scroll-track flex gap-6 hover:[animation-play-state:paused]">
          {duplicatedTestimonials.map((item, idx) => (
            <div
              key={`${item.id}-${idx}`}
              className="w-[300px] md:w-[380px] shrink-0 rounded-2xl border border-stone-200/90 bg-white p-6 md:p-8 shadow-lg transition-all duration-300 hover:border-[#DFB587] hover:shadow-xl hover:scale-[1.02]"
            >
              {/* Stars */}
              <div className="flex gap-1 text-[#DFB587]">
                {[...Array(item.rating || 5)].map((_, i) => (
                  <i key={i} className="fa-solid fa-star text-xs" />
                ))}
              </div>

              {/* Review Text */}
              <p className="mt-4 font-sans text-sm leading-relaxed text-neutral-700 italic">
                "{item.anmeldelse?.da || item.anmeldelse}"
              </p>

              {/* Author */}
              <div className="mt-6 flex items-center gap-3 border-t border-stone-100 pt-4">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#DFB587]/15 border border-[#DFB587]/30 text-sm font-bold text-neutral-900">
                  {item.navn ? item.navn.charAt(0) : 'K'}
                </div>
                <div>
                  <h4 className="font-display text-sm font-semibold text-neutral-900">
                    {item.navn}
                  </h4>
                  <p className="text-[11px] text-neutral-500 uppercase tracking-wider">
                    Verificeret køber
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
